module.exports = __webpack_public_path__ + "img/thumb_26.f3625b3c.jpg";